module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"copyCode":"Copy code","copied":"Copied!","helpText":"Copy code and paste it into your website\u0027s HTML. Learn how in this","learnHow":"Learn how","errorMessage":"The code could not be copied","helpArticle":"help article."}}')
  delete Component.options._Ctor
}
